import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/404",
    },
    {
      path: "/op/:_id",
      name: "iframe",
      component: () => import("./views/Op.vue"),
    },
    {
      path: "/status/:_id/:ids/:uid",
      name: "status",
      component: () => import("./views/Status.vue"),
    },
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/facility",
      name: "facility",
      component: () => import("./views/Facility.vue"),
    },
  ],
});

export default router;
